import {GET_LOGIN_REQUESTED, GET_LOGIN_SUCCESS, GET_LOGIN_FAILED, GET_MAGICTOKEN_REQUESTED, GET_MAGICTOKEN_SUCCESS, GET_MAGICTOKEN_FAILED, GET_TOKENVERIFY_REQUESTED, GET_TOKENVERIFY_SUCCESS, GET_TOKENVERIFY_FAILED} from "resources/actionTypes";

const initialState = {
  userLogin: [],
  loading: false,
  error: null,
};

const initialStateMagicToken = {
  userMagicToken: [],
  loading: false,
  error: null,
}

const initialStateTokenVerify = {
  userTokenVerify: [],
  loading: false,
  error: null,
}

export function userLogin(state = initialState, action) {
  switch (action.type) {
    case GET_LOGIN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userLogin: action.userLogin,
      };
    case GET_LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userMagicToken(state = initialStateMagicToken, action) {
  switch (action.type) {
    case GET_MAGICTOKEN_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_MAGICTOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        userMagicToken: action.userMagicToken,
      };
    case GET_MAGICTOKEN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userTokenVerify(state = initialStateTokenVerify, action) {
  switch (action.type) {
    case GET_TOKENVERIFY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TOKENVERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        userTokenVerify: action.userTokenVerify,
      };
    case GET_TOKENVERIFY_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
